import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'bottom',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    canDel: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currentIndex: 0
    };
  },
  methods: {
    getNameStyle: function getNameStyle(item, index) {
      var _item$font_size = item.font_size,
        font_size = _item$font_size === void 0 ? 26 : _item$font_size,
        _item$font_color = item.font_color,
        font_color = _item$font_color === void 0 ? '#606266' : _item$font_color,
        _item$active_font_col = item.active_font_color,
        active_font_color = _item$active_font_col === void 0 ? '#c20c0c' : _item$active_font_col;
      var baseSize = 32; //基准值 16*2 C端即可直接取值

      var fontSize = font_size / baseSize;
      return {
        'font-size': fontSize + 'rem',
        color: index === this.currentIndex ? active_font_color : font_color
      };
    },
    removeLayout: function removeLayout() {
      this.$emit('removeBottom');
    }
  },
  computed: {
    getLayoutStyle: function getLayoutStyle() {
      var _this$value$config = this.value.config,
        bg_type = _this$value$config.bg_type,
        _this$value$config$bg = _this$value$config.bg_color,
        bg_color = _this$value$config$bg === void 0 ? '#ffffff' : _this$value$config$bg,
        _this$value$config$bg2 = _this$value$config.bg_img,
        bg_img = _this$value$config$bg2 === void 0 ? '' : _this$value$config$bg2;
      return {
        background: bg_type === '2' ? "url(".concat(bg_img, ") no-repeat 0 0 / 100% 100%") : bg_color
      };
    },
    tabBarList: function tabBarList() {
      var _this$value$config2, _this$value$config2$v;
      var list = ((_this$value$config2 = this.value.config) === null || _this$value$config2 === void 0 ? void 0 : (_this$value$config2$v = _this$value$config2.value) === null || _this$value$config2$v === void 0 ? void 0 : _this$value$config2$v.filter(function (i) {
        return Boolean(i.flag);
      })) || [];
      this.currentIndex = 0;
      return list;
    }
  }
};